<template>
  <div>
    <Topbar></Topbar>
    <div class="container-fluid">
      <div v-if="user" class="row" style="padding:40px">
        <div class="col-md-2">
          <span class="oi oi-person" style="font-size:200px;"></span>
        </div>
        <div class="ml-5 col">
          <div class="row">
            <h3>{{user.username}}</h3>
          </div>
          <div class="row">
            <h5>{{user.role}}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from '../components/Topbar'
export default {
  name: 'UserDetail',
  components: {
    Topbar
  },
  mounted () {
    this.axios.get(this.$serverAddr + '/user/' + this.$route.params.userId).then((response) => {
      this.user = response.data[0]
    })
  },
  data () {
    return {
      user: null
    }
  }
}
</script>

<style scoped>

</style>
